"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RejectAttestationBodyToJSON = exports.RejectAttestationBodyFromJSONTyped = exports.RejectAttestationBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function RejectAttestationBodyFromJSON(json) {
    return RejectAttestationBodyFromJSONTyped(json, false);
}
exports.RejectAttestationBodyFromJSON = RejectAttestationBodyFromJSON;
function RejectAttestationBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'attestationId': json['attestationId'],
        'rejectionReason': json['rejectionReason'],
        'adminNotes': !(0, runtime_1.exists)(json, 'adminNotes') ? undefined : json['adminNotes'],
    };
}
exports.RejectAttestationBodyFromJSONTyped = RejectAttestationBodyFromJSONTyped;
function RejectAttestationBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'attestationId': value.attestationId,
        'rejectionReason': value.rejectionReason,
        'adminNotes': value.adminNotes,
    };
}
exports.RejectAttestationBodyToJSON = RejectAttestationBodyToJSON;
